const show = {
    state: {
        addShowDialog: {
            title: '新增展示栏目信息',
            type: 'add'
        }
    },
    getters: {
        addShowDialog: state => state.addShowDialog,
    },
    mutations: {
        SET_SHOW_DIALOG_TITLE: (state, type) => {
            console.log("SET_SHOW_DIALOG_TITLE");
            if (type === 'add') {
                state.addShowDialog.title = '新增展示栏目信息'
                state.addShowDialog.type = 'add'
            } else {
                state.addShowDialog.title = '编辑展示栏目信息'
                state.addShowDialog.type = 'edit'
            }
        }
    },
    actions: {

    }
}

export default show